import React, { useMemo, useState } from "react";
import { PaymentMethod } from "../../pages";
import { TransactionsController } from "../../controllers";

const PaymentMethodContainer = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [currencyCode, setCurrencyCode] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [createPaymentMethodModal, setCreatePaymentMethodModal] =
    useState(false);
  const [editPaymentMethodModal, setEditPaymentMethodModal] = useState(false);
  const [viewMoreModal, setViewMoreModal] = useState(false);

  const paymentMethodTableQuery = useMemo(() => {
    let query = `offset=${currentPage + 1}&limit=${limit}`;

    if (currencyCode) {
      query += `&currencyCode=${currencyCode}`;
    }
    if (countryCode) {
      query += `&countryCode=${countryCode}`;
    }

    return query;
  }, [currentPage, limit, countryCode, currencyCode]);

  // const paymentMethodTableQuery = useMemo(() => {
  //   return `offset=${currentPage + 1}&limit=${limit}`;
  // }, [currentPage, limit]);

  const { isLoading, data, isFetching } =
    TransactionsController.useGetPaymentMethod(
      paymentMethodTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };
  const goToCreatePaymentMethod = () => {
    setCreatePaymentMethodModal(true);
  };
  const goToEditPaymentMethod = () => {
    setEditPaymentMethodModal(true);
  };
  const goToViewMore = () => {
    setViewMoreModal(true);
  };
  const closeModal = () => {
    setCreatePaymentMethodModal(false);
    setEditPaymentMethodModal(false);
    setViewMoreModal(false);
  };

  const filterHandler = async (query) => {
    setFilterQuery(query);
    setCurrencyCode(query);
  };

  return (
    <PaymentMethod
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      onLimitChange={onLimitChange}
      limit={limit}
      currentPage={currentPage}
      searchQuery={searchQuery}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
      goToCreatePaymentMethod={goToCreatePaymentMethod}
      goToEditPaymentMethod={goToEditPaymentMethod}
      createPaymentMethodModal={createPaymentMethodModal}
      editPaymentMethodModal={editPaymentMethodModal}
      closeModal={closeModal}
      filterHandler={filterHandler}
      viewMoreModal={viewMoreModal}
      goToViewMore={goToViewMore}
    />
  );
};

export default PaymentMethodContainer;
